/* eslint-disable max-lines-per-function */
import { Form, Formik } from "formik";
import React from "react";
import * as yup from "yup";
import { Typography, Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Button } from "components/haven-design/buttons";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import { Card } from "components/haven-design";
import { LoneGrid, BackToLogin, LoginCardTitle } from "components/login/components/shared-components";
import loginCss from "components/login/components/Login.module.css";
import { loginAuthColumnSx } from "components/login/components/styles";
import { useRequestResetPasswordEmail } from "./actions";
import { loginStyles } from "./styles";

type ResetPasswordLocationState = {
  email?: string;
  requestedPath?: string;
} | null | undefined;

const ResetPasswordText: React.FC = () => (
  <LoneGrid>
    <Typography variant="subtitle1" style={{ textAlign: "center" }}>
      Enter your email address to reset password
    </Typography>
    <br/>
  </LoneGrid>);

const ResetPassword: React.FC = () => {
  const requestResetPasswordEmail = useRequestResetPasswordEmail();
  const location = useLocation() as { state: ResetPasswordLocationState };

  return (
    <Grid container justifyContent="center" spacing={2} direction="row">
      <Grid size={{ xs: 12 }}> <br /> </Grid>
      <Formik
        initialValues={{ email: location?.state?.email || "" }}
        onSubmit={({ email }) => {
          requestResetPasswordEmail({ email: email.trim().toLowerCase() });
          if (location?.state?.requestedPath) {
            localStorage.setItem("requestedPath", location.state.requestedPath);
          }
        }}
        validationSchema={yup.object().shape({
          email: yup.string().required(),
        })}
      >
        <Form className={loginCss.form}>
          <Card className={loginCss.loginCard}>
            <Grid container spacing={2} direction="column" alignItems="center" justifyContent="center">
              <Grid>
                <LoginCardTitle title="Reset Password" />
              </Grid>
              <Grid>
                <ResetPasswordText />
              </Grid>
              <Grid>
                <LoneGrid>
                  <Grid size={{ xs: 12 }} sx={loginAuthColumnSx}>
                    <InputWithErrorLabel
                      name="email"
                      label="Email"
                      type="text"
                      style={loginStyles.loginInput}
                    />
                  </Grid>
                </LoneGrid>

                <LoneGrid>
                  <Grid size={{ xs: 12 }} sx={loginAuthColumnSx}>
                    <Button
                      color="primary"
                      size="L"
                      type="submit"
                      fullWidth
                      className={loginCss.loginButton}
                      style={loginStyles.btn}
                    >
                      Send Instructions
                    </Button>
                  </Grid>
                </LoneGrid>

                <BackToLogin />
              </Grid>
            </Grid>
          </Card>
        </Form>
      </Formik>
      <Grid size={{ xs: 12 }}>
        <div style={{ height: "5em" }}/>
      </Grid>
    </Grid>
  );
};

export default ResetPassword;
